import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { InfrastructureFilter, ParkingFilter } from '../../../../models/Filter';
import { InfrastructureButtonFilterView } from '../../group/InfrastructureButtonFilterView';

interface IInfrastructureFilter {
    filter: InfrastructureFilter;
    parkingFilter: ParkingFilter;
    handleChange: (value: InfrastructureFilter | ParkingFilter) => void;
    classNameGroup?: string;
}

export const MobileInfrastructureFilterButtonView: React.FC<IInfrastructureFilter> = ({
    filter,
    parkingFilter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Ещё'>
            <InfrastructureButtonFilterView
                filter={filter}
                parkingFilter={parkingFilter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
